'use client'

import type { Form } from '@/payload-types'

import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

// Pré-sélectionne les options des champs select à partir des query params.
// Le nom du paramètre est le `name` du champ dans le form builder,
// ex. `/contact?subject=partenariat` sélectionne l'option de valeur `partenariat` du champ `subject`.
// Une valeur qui ne correspond à aucune option est ignorée.
export const PrefillFromSearchParams: React.FC<{ fields: Form['fields'] }> = ({ fields }) => {
  const searchParams = useSearchParams()
  const { setValue } = useFormContext()

  useEffect(() => {
    fields?.forEach((field) => {
      if (field.blockType !== 'select') return

      const param = searchParams.get(field.name)
      if (param && field.options?.some((option) => option.value === param)) {
        setValue(field.name, param)
      }
    })
  }, [fields, searchParams, setValue])

  return null
}
